module.exports = __webpack_public_path__ + "img/bfly.3a8f3cf4.png";